import http from 'hub-http/clients/apiClient';
import { makeSimpleQuickFetchWrapper } from '../utils/ajaxUtils';
const API_BASE = '/knowledge-content/v1/disabled-interactions-config';
export default class DisabledInteractionsConfigApi {}
DisabledInteractionsConfigApi.getDisabledInteractionsConfig = makeSimpleQuickFetchWrapper('get-disabled-interactions-config', () => http.get(API_BASE));